export const TopProductsData = [
    {
        id: 1,
        img: require('../../../assets/images/dashboard-2/chair.png'),
        title: 'Wood Chair Dark',
        para: '100 Items',
        coupon: 'Coupon Code',
        coupon_para: 'PIX001',
        percent: '-51%',
        price: '$99.00',
        icon:'flag-icon-gb'
    },
    {
        id: 2,
        img: require('../../../assets/images/dashboard-2/shoes.png'),
        title: 'Sneaker For Men',
        para: '150 Items',
        coupon: 'Coupon Code',
        coupon_para: 'PIX002',
        percent: '-78%',
        price: '$66.00',
        icon:'flag-icon-us'
    },
    {
        id: 3,
        img: require('../../../assets/images/dashboard-2/pot.png'),
        title: 'Tree Stylish Pot',
        para: '150 Items',
        coupon: 'Coupon Code',
        coupon_para: 'PIX003',
        percent: '-04%',
        price: '$116.00',
        icon:'flag-icon-za'
    },
    {
        id: 4,
        img: require('../../../assets/images/dashboard-2/purse.png'),
        title: 'Ulrich Duffel Bag',
        para: '600 Items',
        coupon: 'Coupon Code',
        coupon_para: 'PIX004',
        percent: '-60%',
        price: '$99.00',
        icon:'flag-icon-at'
    },
    {
        id: 5,
        img: require('../../../assets/images/dashboard-2/watch.png'),
        title: 'Mi Watch Revolve',
        para: '541 Item',
        coupon: 'Coupon Code',
        coupon_para: 'PIX005',
        percent: '-50%',
        price: '$58.00',
        icon:'flag-icon-br'
    },
    {
        id: 6,
        img: require('../../../assets/images/dashboard-2/watch.png'),
        title: 'Mi Watch Revolve',
        para: '541 Item',
        coupon: 'Coupon Code',
        coupon_para: 'PIX005',
        percent: '-50%',
        price: '$58.00',
        icon:'flag-icon-br'
    },
    {
        id: 7,
        img: require('../../../assets/images/dashboard-2/watch.png'),
        title: 'Mi Watch Revolve',
        para: '541 Item',
        coupon: 'Coupon Code',
        coupon_para: 'PIX005',
        percent: '-50%',
        price: '$58.00',
        icon:'flag-icon-br'
    }
]

export const BestSellersData = [
    {
        id: 1,
        img: require("../../../assets/images/dashboard-2/person1.png"),
        name: 'John Keter',
        para: '2022',
        date: '06 August',
        product: 'Branded Shoes',
        total: '$37,618',
        status: '65%',
        color:'progress-bg-success'
    },
    {
        id: 2,
        img: require("../../../assets/images/dashboard-2/person2.png"),
        name: 'Harry Venter',
        para: '2023',
        date: '21 March',
        product: 'Headphone',
        total: '$59,105',
        status: '45%',
        color:'progress-bg-warning'
    },
    {
        id: 3,
        img: require("../../../assets/images/dashboard-2/person3.png"),
        name: 'Loadin Deo',
        para: '2023',
        date: '09 March',
        product: 'Cell Phone',
        total: '$10,155',
        status: '85%',
        color:'progress-bg-danger'
    },
    {
        id: 4,
        img: require("../../../assets/images/dashboard-2/person4.png"),
        name: 'Horen Hors',
        para: '2023',
        date: '14 February',
        product: 'Fashion',
        total: '$90,568',
        status: '75%',
        color:'progress-bg-info'
    },
    {
        id: 5,
        img: require("../../../assets/images/dashboard-2/person5.png"),
        name: 'Fenter Jessy',
        para: '2023',
        date: '21 January',
        product: 'Bookshop',
        total: '$10,652',
        status: '45%',
        color:'progress-bg-warning'
    },
]

export const ItemsSliderData = [
    {
        id: 1,
        img: require("../../../assets/images/dashboard-2/wellington-shoes.png"),
        // img: shoes,
        badge: 'New',
        title: 'Active',
        title2: 'Customers',
        price: '$199.33',
        color:'bg-secondary'
    },
    {
        id: 2,
        img: require("../../../assets/images/dashboard-2/apple-watch.png"),
        badge: 'Hot',
        title: 'Active',
        title2: 'Connections',
        price: '$990.25',
        color:'bg-primary'
    },
    {
        id: 3,
        img: require("../../../assets/images/dashboard-2/wellington-shoes.png"),
        badge: 'New',
        title: 'Active',
        title2: 'Customers',
        price: '$325.25',
        color:'bg-secondary'
    },
    {
        id: 4,
        img: require("../../../assets/images/dashboard-2/apple-watch.png"),
        badge: 'Hot',
        title: 'Active',
        title2: 'Connections',
        price: '$1185.90',
        color:'bg-primary'
    },
    {
        id: 5,
        img: require("../../../assets/images/dashboard-2/wellington-shoes.png"),
        badge: 'New',
        title: 'Active',
        title2: 'Customers',
        price: '$199.33',
        color:'bg-secondary'
    },
    {
        id: 6,
        img: require("../../../assets/images/dashboard-2/apple-watch.png"),
        badge: 'Hot',
        title: 'Active',
        title2: 'Connections',
        price: '$990.25',
        color:'bg-primary'
    },
]